import { assetUrl } from '../utils/assetUrl';

/**
 * CodeOfConductPage — ported from hp-www-updraft/code-of-conduct.html.
 *
 * Static marketing content. Internal nav uses React Router Link; assets
 * resolve from public/assets/* (relative refs rewritten to /assets/...).
 * Wrapped by SiteLayout at the route level (App.tsx), so this file omits
 * the nav and footer.
 */
export const CodeOfConductPage: React.FC = () => {
  return (
    <>
      {/* HERO */}
      <section className="section section-brown hp-hero-pad-lg" style={{ position: 'relative', overflow: 'hidden' }}>
        <div className="ghost-logo">
          <img src={assetUrl('/logo-cream.svg')} alt="" width="618" height="100" />
        </div>
        <div className="container" style={{ position: 'relative', zIndex: '2', maxWidth: '1000px' }}>
          <div className="eyebrow eyebrow-orange" style={{ marginBottom: '22px' }}>Community Code of Conduct</div>
          <h1 style={{ marginBottom: '28px' }}>A shared social contract<br />not <em className="text-accent" style={{ fontStyle: 'italic', color: 'var(--hp-orange)' }}>fine print</em></h1>
          <p className="lead" style={{ opacity: '0.85', maxWidth: '64ch' }}>
            HomePlated<sup className="tm">™</sup> is hospitality, trust, and community — not just a marketplace. This is what we expect of each other, in plain language, so every meal feels like one a neighbor would proudly serve their own family.
          </p>
        </div>
      </section>

      {/* CHEF CODE */}
      <section className="section section-cream">
        <div className="container" style={{ maxWidth: '1100px' }}>
          <div style={{ textAlign: 'center', maxWidth: '760px', margin: '0 auto 48px' }}>
            <div className="eyebrow eyebrow-orange" style={{ marginBottom: '18px' }}>For chefs</div>
            <h2 style={{ marginBottom: '18px', fontSize: 'clamp(26px, 3.2vw, 40px)', lineHeight: '1.25', textWrap: 'balance' }}>You are not just cooking food&nbsp;— you are <em className="text-accent sm" style={{ fontStyle: 'italic', color: 'var(--hp-orange)' }}>caring for your community.</em></h2>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-orange)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-orange)', fontWeight: '700', marginBottom: '10px' }}>01</div>
              <h4 style={{ marginBottom: '12px' }}>Food safety is non-negotiable</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>Wash hands thoroughly before and during food preparation.</li>
                <li>Maintain a clean, sanitary kitchen environment.</li>
                <li>Store, cook, and transport food at safe temperatures.</li>
                <li>Never serve food you would not confidently serve your own family.</li>
              </ul>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-green)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-green)', fontWeight: '700', marginBottom: '10px' }}>02</div>
              <h4 style={{ marginBottom: '12px' }}>Honesty &amp; transparency</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>Accurately describe your dish, ingredients, and portion sizes.</li>
                <li>Do not misrepresent quality, dietary claims, or preparation methods.</li>
                <li>Clearly communicate pickup time, location, and expectations — and edit or cancel as needed.</li>
              </ul>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-blue)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-blue)', fontWeight: '700', marginBottom: '10px' }}>03</div>
              <h4 style={{ marginBottom: '12px' }}>Reliability &amp; respect for time</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>Be ready during your stated pickup window.</li>
                <li>Edit and notify eaters immediately of any delays or cancellations.</li>
                <li>Respect that eaters are planning their time around what you promised.</li>
              </ul>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-gold)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-gold)', fontWeight: '700', marginBottom: '10px' }}>04</div>
              <h4 style={{ marginBottom: '12px' }}>Hospitality first</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>Be warm, welcoming, and gracious.</li>
                <li>A simple smile, greeting, or small gesture goes a long way.</li>
                <li>You are creating an experience, not just handing off food.</li>
              </ul>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-brown)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-brown)', fontWeight: '700', marginBottom: '10px' }}>05</div>
              <h4 style={{ marginBottom: '12px' }}>Prohibited activity</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>No sale or distribution of alcohol, drugs or controlled substances, or unsafe / non-food items.</li>
                <li>No discriminatory, harassing, or inappropriate behavior.</li>
              </ul>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-puke)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-puke-shade)', fontWeight: '700', marginBottom: '10px' }}>06</div>
              <h4 style={{ marginBottom: '12px' }}>Community mindset</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>Start small, grow responsibly.</li>
                <li>Avoid waste whenever possible.</li>
                <li>Support fellow chefs and the broader HomePlated<sup className="tm">™</sup> community.</li>
              </ul>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-orange)', gridColumn: '1 / -1' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-orange)', fontWeight: '700', marginBottom: '10px' }}>07</div>
              <h4 style={{ marginBottom: '12px' }}>Packaging &amp; care</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>Use clean, appropriate, and leak-proof containers.</li>
                <li>Separate components when needed (e.g., sauces, rice).</li>
                <li>You are not responsible for utensils.</li>
              </ul>
            </div>
          </div>

          {/* Chef enforcement */}
          <div style={{ marginTop: '48px', background: 'var(--hp-cream-warm)', borderRadius: '24px', padding: '36px', border: '1px solid rgba(143,68,32,.08)' }}>
            <div className="eyebrow eyebrow-orange" style={{ marginBottom: '16px' }}>Chef enforcement policy</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px' }}>
              <div>
                <h4 style={{ marginBottom: '10px' }}>1st infraction</h4>
                <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.75)', fontSize: '15px', lineHeight: '1.6' }}>
                  <li>Account suspended for 60 days.</li>
                  <li>Countdown timer visible in app.</li>
                  <li>Re-entry requires acknowledgment of the Code of Conduct.</li>
                </ul>
              </div>
              <div>
                <h4 style={{ marginBottom: '10px' }}>2nd infraction</h4>
                <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.75)', fontSize: '15px', lineHeight: '1.6' }}>
                  <li>Permanent account suspension.</li>
                  <li>Option to submit a formal appeal.</li>
                  <li>Reinstatement, if granted, may require completion of food-safety training, a reinstatement fine, and probationary status.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* EATER CODE */}
      <section className="section section-warm">
        <div className="container" style={{ maxWidth: '1100px' }}>
          <div style={{ textAlign: 'center', maxWidth: '760px', margin: '0 auto 48px' }}>
            <div className="eyebrow eyebrow-green" style={{ marginBottom: '18px' }}>For eaters</div>
            <h2 style={{ marginBottom: '18px', fontSize: 'clamp(26px, 3.2vw, 40px)', lineHeight: '1.25', textWrap: 'balance' }}>You are not just receiving food&nbsp;— you are <em className="text-accent green sm" style={{ fontStyle: 'italic', color: 'var(--hp-green)' }}>participating in a community.</em></h2>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-green)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-green)', fontWeight: '700', marginBottom: '10px' }}>01</div>
              <h4 style={{ marginBottom: '12px' }}>Respect &amp; kindness</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>Treat chefs with courtesy and appreciation.</li>
                <li>Respect their home, time, and effort.</li>
                <li>No harassment, discrimination, or inappropriate behavior.</li>
              </ul>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-orange)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-orange)', fontWeight: '700', marginBottom: '10px' }}>02</div>
              <h4 style={{ marginBottom: '12px' }}>Punctuality &amp; communication</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>Arrive within the pickup window.</li>
                <li>Communicate delays or cancellations promptly.</li>
                <li>Do not "no-show" without notice.</li>
              </ul>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-blue)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-blue)', fontWeight: '700', marginBottom: '10px' }}>03</div>
              <h4 style={{ marginBottom: '12px' }}>Honest &amp; constructive feedback</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>Leave fair, respectful reviews.</li>
                <li>Avoid exaggeration or harmful intent.</li>
                <li>Help improve the community, not tear it down.</li>
              </ul>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-gold)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-gold)', fontWeight: '700', marginBottom: '10px' }}>04 · Critical</div>
              <h4 style={{ marginBottom: '12px' }}>Personal responsibility</h4>
              <p style={{ margin: '0 0 10px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>You are responsible for your own dietary restrictions, allergies and sensitivities, and your own utensils and food handling after pickup.</p>
              <p style={{ margin: '0', color: 'var(--hp-brown-deep)', fontSize: '14px', fontStyle: 'italic' }}>If you have serious allergies or medical conditions, exercise extreme caution before ordering — or do not participate.</p>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-brown)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-brown)', fontWeight: '700', marginBottom: '10px' }}>05</div>
              <h4 style={{ marginBottom: '12px' }}>Zero tolerance behavior</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>No attempts to solicit off-platform transactions inappropriately.</li>
                <li>No attempts to exploit, threaten, or intimidate chefs.</li>
                <li>No abusive refund or complaint behavior.</li>
              </ul>
            </div>

            <div style={{ background: 'white', borderRadius: '22px', padding: '32px', borderLeft: '4px solid var(--hp-puke)' }}>
              <div style={{ fontSize: '13px', letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--hp-puke-shade)', fontWeight: '700', marginBottom: '10px' }}>06</div>
              <h4 style={{ marginBottom: '12px' }}>Community participation</h4>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.6' }}>
                <li>Be patient — this is a growing ecosystem.</li>
                <li>Support chefs who are learning and improving.</li>
                <li>Encourage and uplift the community.</li>
              </ul>
            </div>
          </div>

          {/* Eater enforcement */}
          <div style={{ marginTop: '48px', background: 'white', borderRadius: '24px', padding: '36px', border: '1px solid rgba(143,68,32,.08)' }}>
            <div className="eyebrow eyebrow-green" style={{ marginBottom: '16px' }}>Eater enforcement policy</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px' }}>
              <div>
                <h4 style={{ marginBottom: '10px' }}>1st infraction</h4>
                <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.75)', fontSize: '15px', lineHeight: '1.6' }}>
                  <li>Account suspended for 60 days.</li>
                  <li>Countdown timer visible in app.</li>
                  <li>Re-entry requires acknowledgment of the Code of Conduct.</li>
                </ul>
              </div>
              <div>
                <h4 style={{ marginBottom: '10px' }}>2nd infraction</h4>
                <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.75)', fontSize: '15px', lineHeight: '1.6' }}>
                  <li>Permanent account suspension.</li>
                  <li>Option to appeal.</li>
                  <li>Reinstatement, if granted, may require written acknowledgment of violations, a reinstatement fine, and probationary participation.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COMMUNITY ENFORCEMENT PRINCIPLES */}
      <section className="section" style={{ background: 'var(--hp-brown-deep)', color: 'var(--hp-cream)' }}>
        <div className="container" style={{ maxWidth: '1000px' }}>
          <div className="hp-grid-gap-md" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', alignItems: 'flex-start' }}>
            <div>
              <div className="eyebrow eyebrow-orange" style={{ marginBottom: '18px' }}>Applies to both</div>
              <h2 style={{ marginBottom: '20px' }}>Community enforcement<br />principles</h2>
              <p className="lead" style={{ opacity: '0.8', maxWidth: '50ch' }}>
                HomePlated<sup className="tm">™</sup> is a closed loop. We protect the network actively, not reactively — and we err on the side of the people doing this right.
              </p>
            </div>
            <ul style={{ listStyle: 'none', padding: '0', margin: '0', display: 'grid', gap: '16px' }}>
              <li style={{ background: 'rgba(241,237,225,0.06)', border: '1px solid rgba(241,237,225,0.12)', borderRadius: '18px', padding: '22px 26px' }}>
                <strong style={{ display: 'block', marginBottom: '4px' }}>We reserve the right to restrict or remove access at any time.</strong>
                <span style={{ fontSize: '14px', opacity: '0.7' }}>For violations of this Code, our Terms, or applicable law.</span>
              </li>
              <li style={{ background: 'rgba(241,237,225,0.06)', border: '1px solid rgba(241,237,225,0.12)', borderRadius: '18px', padding: '22px 26px' }}>
                <strong style={{ display: 'block', marginBottom: '4px' }}>We investigate complaints using platform data.</strong>
                <span style={{ fontSize: '14px', opacity: '0.7' }}>Order history, messages, reviews, and timestamps — the minimum needed to act fairly.</span>
              </li>
              <li style={{ background: 'rgba(241,237,225,0.06)', border: '1px solid rgba(241,237,225,0.12)', borderRadius: '18px', padding: '22px 26px' }}>
                <strong style={{ display: 'block', marginBottom: '4px' }}>Repeated complaints, even if minor, may trigger review.</strong>
                <span style={{ fontSize: '14px', opacity: '0.7' }}>Patterns matter as much as individual incidents.</span>
              </li>
              <li style={{ background: 'rgba(241,237,225,0.06)', border: '1px solid rgba(241,237,225,0.12)', borderRadius: '18px', padding: '22px 26px' }}>
                <strong style={{ display: 'block', marginBottom: '4px' }}>Severe violations may result in immediate suspension — no warning.</strong>
                <span style={{ fontSize: '14px', opacity: '0.7' }}>Safety, harassment, and fraud are not progressive offenses.</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* FINAL STATEMENT */}
      <section className="section section-cream" style={{ textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: '820px' }}>
          <div className="eyebrow eyebrow-orange" style={{ marginBottom: '22px' }}>Final community statement</div>
          <p style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 'clamp(24px, 2.6vw, 32px)', lineHeight: '1.4', color: 'var(--hp-brown-deep)', margin: '0 0 36px' }}>
            HomePlated<sup className="tm">™</sup> is built on trust, generosity, and shared humanity.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left', marginTop: '12px' }}>
            <div style={{ background: 'white', borderRadius: '22px', padding: '28px', border: '1px solid rgba(143,68,32,.08)' }}>
              <strong style={{ display: 'block', marginBottom: '10px', color: 'var(--hp-brown-deep)' }}>If you're here for</strong>
              <ul style={{ margin: '0', paddingLeft: '18px', color: 'rgba(42,22,9,.72)', fontSize: '15px', lineHeight: '1.7' }}>
                <li>perfection over participation,</li>
                <li>transactions over relationships,</li>
                <li>or conflict over community —</li>
              </ul>
              <p style={{ margin: '14px 0 0', color: 'var(--hp-brown-deep)', fontWeight: '600' }}>this is not the right platform for you.</p>
            </div>
            <div style={{ background: 'var(--hp-orange)', color: 'white', borderRadius: '22px', padding: '28px' }}>
              <strong style={{ display: 'block', marginBottom: '10px' }}>But if you believe</strong>
              <ul style={{ margin: '0', paddingLeft: '18px', fontSize: '15px', lineHeight: '1.7' }}>
                <li>food brings people together,</li>
                <li>small acts of kindness and generosity matter,</li>
                <li>community is worth building —</li>
              </ul>
              <p style={{ margin: '14px 0 0', fontWeight: '700' }}>welcome. You belong here.</p>
            </div>
          </div>
          <p style={{ margin: '40px 0 0', fontSize: '13px', opacity: '0.55' }}>Last updated: May 2026</p>
        </div>
      </section>
    </>
  );
};
